"use strict";

exports.__esModule = true;
exports.OrderClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const OrderClient = {
  /**
   * @description Return the orders of a customer
   *
   * @param {Number} page
   * @param {Number} limit
   * @returns {Promise}
   */
  fetch(page = 1, limit = 100, isTajawal, isV2 = false) {
    const requestId = 'ORDERS';
    const {
      ACCOMMODATION,
      FLIGHT,
      HOTEL,
      GIFTCARD,
      ACTIVITY
    } = _constants.PRODUCT_TYPES;
    const endPoint = isV2 ? _constants.ENDPOINTS.ORDERS_V2 : _constants.ENDPOINTS.ORDERS;
    return _http.$http.get(requestId, endPoint, {
      params: {
        page,
        limit,
        isTajawal,
        type: `${ACCOMMODATION},${FLIGHT},${HOTEL},${GIFTCARD},${ACTIVITY},points-exchange`
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * @description Return the orders of a customer from V1 endpoint
   *
   * @param {Number} page
   * @returns {Promise}
   */
  fetchV1(page = 1, limit = 100) {
    const requestId = 'ORDERS_V1';
    return _http.$http.get(requestId, _constants.ENDPOINTS.ORDERS_V1, {
      params: {
        page,
        limit
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * @description retrieve order by email and order number
   *
   * @param {Number} number
   * @param {email} email
   * @returns {Promise}
   */
  getOrder({
    orderId
  }) {
    const requestId = 'RETRIEVE_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_ORDER, {
      orderId
    });
    return _http.$http.get(requestId, endPoint, {
      params: {
        orderId
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * @description retrieve order by email and order number
   *
   * @param {Number} number
   * @param {email} email
   * @returns {Promise}
   */
  retrieveOrder({
    email,
    number
  }) {
    const requestId = 'RETRIEVE_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.RETRIEVE_ORDER, {
      number
    });
    return _http.$http.get(requestId, endPoint, {
      params: {
        email,
        number
      }
    }).then(({
      data
    }) => data);
  },
  /**
   * @description retrieve flights order by email and order number
   *
   * @param {Number} number
   * @param {email} email
   * @returns {Promise}
   */
  retrieveFlightsOrder({
    email,
    number
  }) {
    const requestId = 'RETRIEVE_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.RETRIEVE_FLIGHTS_ORDER, {
      number
    });
    return _http.$http.get(requestId, endPoint, {
      params: {
        email,
        number
      }
    }).then(({
      data
    }) => data);
  }
};
exports.OrderClient = OrderClient;